import BoardNotFoundError from '../../boards/errors/BoardNotFoundError'
import { BaseMoveError } from '../../errors/BaseMoveError'
import SwimlaneNotFoundError from '../../swimlanes/errors/SwimlaneNotFoundError'
import TaskNotFoundError from './TaskNotFoundError'

/**
 * Possible errors associated with a task move
 */
enum TaskMoveErrorTypes {
    FromBoard,
    FromSwimlane,
    FromTask,
    ToBoard,
    ToSwimlane,
    ToTask,
}

/**
 * Error thrown if an exception takes place whilst processing
 * a task move request.
 * Underlying error can be one of the following:
 * BoardNotFound -> For both source and destination boards
 * SwimlaneNotFound -> For both source and destination boards
 * TaskNotFound -> For the task to be moved
 * OrderInvalid -> If the order supplied for the target is invalid
 */
class TaskMoveError extends BaseMoveError<
    TaskMoveErrorTypes,
    BoardNotFoundError | SwimlaneNotFoundError | TaskNotFoundError
> {}

export { TaskMoveError, TaskMoveErrorTypes }
